import { PLANS, PLANS_OPTIONS } from '@stores/constants';
import { useTypedDispatch, useTypedSelector } from '@stores/index';
import {
  getPlansByUserId,
  postPlanByClientId,
  postPlansByUserId,
  updatePlanByUserId,
} from '@stores/settings/setings';
import { Button, message, Popover, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css'

const { Option } = Select;

interface IFeatures {
  planType: string;
  options: string[]
}

export default function Features() {
  const [validationError, setValidationError] = useState<string | null>(null);
  const dispatch = useTypedDispatch();
  const user = useTypedSelector(state => state.user);
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined);

  const features: IFeatures[] = [
    {
      planType: PLANS.PLAN1,
      options: [
        t('Patient.data.onboard.getScoreOption1'),
        t('Patient.data.onboard.getScoreOption2'),
        t('Patient.data.onboard.getScoreOption3'),
      ],
    },
    {
      planType: PLANS.PLAN2,
      options: [
        t('Patient.data.onboard.commitEarlyOption1'),
        t('Patient.data.onboard.commitEarlyOption2'),
        t('Patient.data.onboard.commitEarlyOption3'),
      ],
    },
    {
      planType: PLANS.PLAN3,
      options: [
        t('Patient.data.onboard.recoverSupportOption1'),
        t('Patient.data.onboard.recoverSupportOption2'),
        t('Patient.data.onboard.recoverSupportOption3'),
        t('Patient.data.onboard.recoverSupportOption4'),
        t('Patient.data.onboard.recoverSupportOption5'),
        t('Patient.data.onboard.recoverSupportOption6'),
      ],
    },
  ];

  useEffect(() => {
    if (user?.id) {
      initializePlans();
    }
  }, [dispatch, user?.id]);

  const initializePlans = async () => {
    const data = await dispatch(getPlansByUserId(user?.id));
    const userPlanType = data?.payload?.planType;
    const matched = PLANS_OPTIONS?.find(opt => opt.value === userPlanType);
    if (matched) {
      setSelectedValue(matched?.value);
    }
  };

  const handleChange = (value: string) => {
    setSelectedValue(value);
    setValidationError(null);
  };

  const updateForm = async () => {
    if (!selectedValue) {
      setValidationError(t('Admin.data.menu.setting.selectonePlan'));
      return;
    }
    const payload = { userId: user?.id, planType: selectedValue };
    const plansByClientIdPayload = { clientId: user?.clientId, planType: selectedValue };
    const response = selectedValue
      ? await dispatch(updatePlanByUserId(payload))
      : await dispatch(postPlansByUserId(payload));
    await dispatch(postPlanByClientId(plansByClientIdPayload));
    if (response?.payload) {
      message.success(t('Admin.data.menu.setting.updatedSuccess'));
    }
  };

  return (
    <>
      <div className="mt-4 feature">
        <div
          style={{
            display: 'flex',
            color: 'var(--content-manager-card-header-text-color)',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: '12px',
          }}>
          <span>{t('Admin.data.menu.setting.selectPlan')}</span>
        </div>
        <Select
          placeholder={t('Admin.data.menu.setting.selectPlan')}
          className="select-plan-input-item"
          style={{ width: '100%', height: '48px' }}
          value={selectedValue}
          onChange={handleChange}
          dropdownClassName="feature-option-class"
          dropdownStyle={{ minWidth: '752px' }}
          optionLabelProp="plan"
          allowClear>
          {PLANS_OPTIONS?.map(option => (
            <Option key={option?.id} value={option?.value} plan={option?.plan}>
              <Popover
                content={() => {
                  const matchedFeature = features?.find(f => f?.planType === option?.plan);
                  return (
                    <div className="custom-popover-content">
                      {matchedFeature ? (
                        <ul
                          style={{
                            listStyleType: 'disc',
                            paddingLeft: '20px',
                            margin: 0,
                          }}>
                          {matchedFeature?.options?.map(
                            (opt: string, i: number) => (
                              <li key={i} style={{ color: 'white' }}>
                                {opt}
                              </li>
                            ),
                          )}
                        </ul>
                      ) : (
                        <p>{t('Admin.data.menu.setting.noPlanFound')}</p>
                      )}
                    </div>
                  );
                }}
                placement="right"
                overlayClassName="custom-popover"
                mouseEnterDelay={0.2}>
                <strong>{option?.plan}</strong> - {option?.label}
              </Popover>
            </Option>
          ))}
        </Select>
      </div>
      {validationError && <p style={{ color: 'red' }}>{validationError}</p>}
      <div style={{display: 'flex', justifyContent: 'center'}}>
      <Button
				style={{
					marginTop: '20px',
          backgroundColor: 'var(--settings-button-bg-color)',
          color: 'var(--settings-button-text-color)',
          border: 'none',
				}}
        onClick={updateForm}>
        {t('Admin.data.menu.setting.update')}
      </Button>
      </div>
    </>
  );
}
